// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chevron-left.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chevron-left',
  version: 'outline',
  paths: [
    {
      d: 'M15.75 19.5 8.25 12l7.5-7.5',
    },
  ],
}
